import { useQuery } from '@tanstack/react-query';
import { SessionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useSessionsControllerGetAllSessionsByUserIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['sessionsControllerGetAllSessionsByUserId', accessControlScope, args],
        queryFn: async () => {
            const api = new SessionsApi(accessControlConfig);
            return api.sessionsControllerGetAllSessionsByUserId(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useSessionsControllerGetAllSessionsByUserIdQuery.js.map